/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'luminaire': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<g _fill="#0f1113"><path pid="0" d="M2.782 6.031c0 1.697.717 3.228 1.886 4.323 1.631 1.544 1.971 2.168 1.995 2.71v.883h4.685v-.93c.038-.542.414-1.166 1.997-2.663a5.904 5.904 0 001.886-4.323C15.231 2.697 12.444 0 9 0S2.769 2.697 2.769 6.031h.013zM6.286 14.325h5.453v1.673a.607.607 0 01-.391.554v.954c0 .27-.231.494-.511.494H7.186a.506.506 0 01-.511-.494v-.954a.58.58 0 01-.389-.554v-1.673z"/></g>'
  }
})
